import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
export const SelectDueDateContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  max-width: 380px;
  margin: auto;
  @media ${query.lessThanSmall} {
    margin: auto;
    width: 90%;
  }
`;
